"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ContactSection;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var button_1 = require("@/components/ui/button");
var input_1 = require("@/components/ui/input");
var use_toast_1 = require("@/hooks/use-toast");
var LanguageContext_1 = require("@/contexts/LanguageContext");
var site_1 = require("@/config/site");
function ContactSection() {
    var _this = this;
    var _a = (0, LanguageContext_1.useLanguage)(), t = _a.t, currentLanguage = _a.currentLanguage;
    var toast = (0, use_toast_1.useToast)().toast;
    var _b = (0, react_1.useState)(""), email = _b[0], setEmail = _b[1];
    var _c = (0, react_1.useState)(false), loading = _c[0], setLoading = _c[1];
    var trackEvent = function (action, category, label) {
        if (typeof window !== "undefined" && window.gtag) {
            window.gtag("event", action, {
                event_category: category,
                event_label: label,
                language: currentLanguage,
            });
        }
    };
    var onSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var valid, res, data, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    e.preventDefault();
                    valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
                    if (!valid) {
                        trackEvent("form_validation_error", "form", "invalid_email");
                        toast({ title: t("form.invalidEmail"), description: t("form.invalidEmailDescription") });
                        return [2 /*return*/];
                    }
                    trackEvent("form_submit", "form", "email_signup");
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 7, 8, 9]);
                    setLoading(true);
                    return [4 /*yield*/, fetch("/api/contact", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json; charset=UTF-8",
                                Accept: "application/json",
                            },
                            body: JSON.stringify({ email: email }),
                        })];
                case 2:
                    res = _c.sent();
                    data = null;
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, res.json()];
                case 4:
                    data = _c.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _a = _c.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (data && data.status === 200) {
                        trackEvent("form_success", "form", "email_signup_success");
                        toast({ title: t("form.thankYou"), description: data.message || t("form.successMessage") });
                        setEmail("");
                    }
                    else {
                        trackEvent("form_error", "form", "email_signup_error");
                        toast({
                            title: t("form.couldNotSend"),
                            description: (data === null || data === void 0 ? void 0 : data.message) || t("form.emailRequired"),
                        });
                    }
                    return [3 /*break*/, 9];
                case 7:
                    _b = _c.sent();
                    trackEvent("form_failure", "form", "email_signup_failure");
                    toast({ title: t("form.somethingWentWrong"), description: t("form.tryAgain") });
                    return [3 /*break*/, 9];
                case 8:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)("section", { id: "contacto", className: "scroll-mt-20 py-16 sm:py-20", children: (0, jsx_runtime_1.jsxs)("div", { className: "mx-auto grid max-w-6xl gap-12 px-4 sm:px-6 lg:grid-cols-2", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-3xl font-semibold tracking-tight sm:text-4xl", children: t("contact.title") }), (0, jsx_runtime_1.jsx)("p", { className: "mt-4 text-muted-foreground", children: t("contact.intro") }), (0, jsx_runtime_1.jsxs)("ul", { className: "mt-8 space-y-4", children: [(0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("p", { className: "text-xs font-semibold uppercase tracking-wide text-muted-foreground", children: t("contact.administracionLabel") }), (0, jsx_runtime_1.jsx)("a", { className: "text-lg font-medium text-primary hover:underline", href: "mailto:".concat(site_1.siteConfig.emails.administracion), children: site_1.siteConfig.emails.administracion })] }), (0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("p", { className: "text-xs font-semibold uppercase tracking-wide text-muted-foreground", children: t("contact.contactoLabel") }), (0, jsx_runtime_1.jsx)("a", { className: "text-lg font-medium text-primary hover:underline", href: "mailto:".concat(site_1.siteConfig.emails.contacto), children: site_1.siteConfig.emails.contacto })] }), (0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("p", { className: "text-xs font-semibold uppercase tracking-wide text-muted-foreground", children: t("contact.infoLabel") }), (0, jsx_runtime_1.jsx)("a", { className: "text-lg font-medium text-primary hover:underline", href: "mailto:".concat(site_1.siteConfig.emails.info), children: site_1.siteConfig.emails.info })] })] })] }), (0, jsx_runtime_1.jsxs)("div", { id: "disponible-pronto", className: "rounded-2xl border border-border bg-card p-6 sm:p-8", children: [(0, jsx_runtime_1.jsx)("h3", { className: "text-xl font-semibold", children: t("contact.waitlistTitle") }), (0, jsx_runtime_1.jsx)("p", { className: "mt-2 text-sm text-muted-foreground", children: t("contact.waitlistBody") }), (0, jsx_runtime_1.jsxs)("p", { className: "mt-4 text-sm text-muted-foreground", children: [(0, jsx_runtime_1.jsxs)("strong", { className: "font-medium text-foreground", children: [t("contact.availableSoonTitle"), "."] }), " ", t("contact.availableSoonBody")] }), (0, jsx_runtime_1.jsxs)("form", { onSubmit: onSubmit, className: "mt-6 space-y-3", children: [(0, jsx_runtime_1.jsx)("label", { className: "sr-only", htmlFor: "notify-email", children: "Email" }), (0, jsx_runtime_1.jsx)(input_1.Input, { id: "notify-email", type: "email", autoComplete: "email", value: email, onChange: function (e) { return setEmail(e.target.value); }, placeholder: t("contact.emailPlaceholder"), className: "min-h-11", required: true }), (0, jsx_runtime_1.jsx)(button_1.Button, { type: "submit", className: "min-h-11 w-full sm:w-auto", disabled: loading, children: loading ? t("contact.sendingButton") : t("contact.submitButton") }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-muted-foreground", children: t("contact.privacyNote") })] })] })] }) }));
}
